/**
 * User Lifecycle Types
 *
 * GDPR Article 17 + SOC 2 compliant user deletion shapes. Mirrors the
 * `user_tombstones` table (init-db/46-user-lifecycle.sql) and its repository.
 */
import { z } from 'zod';
// =============================================================================
// UserTombstone - matches userTombstonesRepository.UserTombstone exactly
// =============================================================================
export const UserTombstoneSchema = z.object({
    userId: z.string().uuid(),
    organizationId: z.string(),
    deletedByUserId: z.string().uuid(),
    deletedAt: z.string(), // ISO 8601
    hardensAt: z.string(), // ISO 8601
    hardenedAt: z.string().nullable(), // ISO 8601 or null while pending
    formerRole: z.string(),
    formerEmail: z.string(),
    formerName: z.string().nullable(),
    selfDelete: z.boolean(),
    reason: z.string().nullable(),
});
// =============================================================================
// DeletionScheduledResponse - returned by DELETE endpoints
// =============================================================================
export const DeletionScheduledResponseSchema = z.object({
    userId: z.string().uuid(),
    deletedAt: z.string(),
    hardensAt: z.string(),
    reassignedActionItemCount: z.number().int().nonnegative().optional(),
    unassignedActionItemCount: z.number().int().nonnegative().optional(),
    reassignedDealCount: z.number().int().nonnegative().optional(),
    unassignedDealCount: z.number().int().nonnegative().optional(),
});
// =============================================================================
// DeletionImpact - current open work that needs a disposition before deletion
// =============================================================================
export const DeletionImpactResponseSchema = z.object({
    userId: z.string().uuid(),
    activeDealCount: z.number().int().nonnegative(),
});
// =============================================================================
// DeletionRequestStatus - cancelled rows are deleted, so no enum entry needed
// =============================================================================
export const DeletionRequestStatusSchema = z.enum(['pending', 'hardened']);
